export enum Status {
    Active,
    InActive,
    Pending,
    Rejected,
    Draft,
    Archived,
    Deleted,
    NotComplete,
    Completed
}
